import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./shipping-policy.css";

export default function ShippingPolicy() {
  return (
    <>
      <Header />

      <main className="shipping-page">
        <div className="shipping-hero">
          <h1>Shipping Policy</h1>
          <p>
            At Aethearia, all our candles are handcrafted and made to order to
            ensure freshness, quality, and attention to detail.
          </p>
        </div>

        <div className="shipping-grid">
          <section className="shipping-card">
            <span className="section-tag">Shipping</span>

            <h3>Order Processing & Dispatch</h3>

            <ul>
              <li>
                Orders are typically processed within 1–3 business days. Since
                each candle is freshly handcrafted, dispatch timelines may vary
                slightly during high-demand periods.
              </li>
              <li>
                Orders placed on weekends or public holidays will be processed on
                the next business day.
              </li>
              <li>
                Once your order is shipped, you will receive a shipping
                confirmation with tracking details via email/SMS/WhatsApp.
              </li>
            </ul>

            <h3>Estimated Delivery Timeline</h3>

            <ul>
              <li>
                Orders are generally delivered within 10–15 business days,
                depending on your location and order volume.
              </li>
              <li>
                Please note that delivery timelines may occasionally vary due to
                public holidays, weather conditions, courier delays, or
                unforeseen circumstances.
              </li>
              <li>
                If you need your order sooner, feel free to contact us on
                99755 11512, and we’ll do our best to accommodate your request.
              </li>
            </ul>
          </section>

          <section className="shipping-card">
            <span className="section-tag">Shipping Charges</span>

            <h2>Shipping Charges</h2>

            <ul>
              <li>Free shipping on prepaid orders of ₹ 2000 & above.</li>
              <li>
                Standard shipping charges may apply to orders below the free
                shipping threshold.
              </li>
              <li>
                Cash on Delivery (COD) may be available at an additional charge.
              </li>
            </ul>

            <h3>Packaging & Care</h3>

          <p>
            We take utmost care in packaging our products using protective
            materials to ensure they reach you safely. In the rare event of
            transit damage or an incorrect item, please contact us within 48
            hours of delivery at{" "}
            <span className="email-lowercase">reachus@aethearia.com</span>, along with
            photos/videos and an unboxing video of the parcel.
          </p>

            <p className="note-highlight">
              Please keep an unboxing video for damaged, missing, or incorrect
              item claims.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}